import { Link } from 'react-router-dom';
import logo from "../../assets/edutri/edutri-logo-3.png";
const Header = () => {

  return (
    <header className="fixed  z-50 top-0 w-full ">
      <nav className="flex justify-between items-center md:mx-[70px] mx-2  md:py-2 ">
        <Link to="/" className="no-underline ">
          <div className="flex gap-2 items-center">
            <img className="md:h-[40.5px] h-[24px] w-[100%] relative object-cover" loading="eager" alt="" src={logo} />
            {/* <b className="relative text-white whitespace-nowrap md:text-lg">Edutri</b> */}
          </div>
        </Link>
        <div className="flex items-center">
          <p className="md:m-[20px] max-md:my-[20px]  max-md:mr-1 text-[1.3vh] md:text-[1vw] whitespace-nowrap font-bold">Alreay Have a account? </p>
          <Link
            className=" text-[#ff820f] border-2 border-solid border-[#ff820f] whitespace-nowrap   text-center py-1 px-2 md:px-3 md:py-2 rounded-full cursor-pointer text-[1.5vh] md:text-[1.3vw] no-underline mr-3"
            to="/login"
          >
            Login
          </Link>
        </div>
      </nav>

    </header>
  );
}

export default Header;
